// extracted by mini-css-extract-plugin
export var cartContainer = "_mp-4";
export var gray = "_mp-1";
export var itemContainer = "_mp-2";
export var itemDetails = "_mp-3";
export var strong = "_mp-0";